import { useQuery } from 'data-fetching-client';
import { GET_ALL_PRICING_PURCHASABLE_PRODUCTS } from 'pricing-pages-api/purchase-options/queries';
import { JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { CurrencyCodes } from 'pricing-pages-ui-components/constants/CurrencyCodes';
import { getI18nLanguage } from 'pricing-pages-ui-components/utils/languageUtils';
import { useCurrencyData } from './useCurrencyData';
const STARTER_PRODUCT_API_NAME = 'marketing-hub-starter';

// Pages where the banner should be displayed
const INCLUDED_PAGES = ['SUITE', 'MARKETING', 'SALES', 'SERVICE', 'DATA', 'CMS', 'CONTENT', 'FREE'];
export const useStarterPromo2025 = ({
  screen,
  tab,
  noAuth
}) => {
  var _COUNTRY_CODE_FROM_LO, _data$bulkPurchaseOpt, _starterProduct$purch, _starterProduct$purch2, _annualPurchaseOption, _monthlyPurchaseOptio, _annualPurchaseOption2, _monthlyPurchaseOptio2;
  const {
    displayedCurrencyCode,
    loading: currencyLoading
  } = useCurrencyData();
  const language = (getI18nLanguage() || 'en').toUpperCase();
  const preferredCountryCode = ((_COUNTRY_CODE_FROM_LO = window.COUNTRY_CODE_FROM_LOCALE) === null || _COUNTRY_CODE_FROM_LO === void 0 ? void 0 : _COUNTRY_CODE_FROM_LO.toUpperCase()) || 'US';

  // Only proceed if we have a supported currency
  const supportedCurrencyCode = displayedCurrencyCode && Object.values(CurrencyCodes).includes(displayedCurrencyCode) ? displayedCurrencyCode : null;
  const queryVariables = {
    noAuth: noAuth !== null && noAuth !== void 0 ? noAuth : true,
    // Default to public context if not specified
    currencyCode: displayedCurrencyCode,
    language,
    preferredCountryCode
  };
  const {
    data,
    loading: purchaseOptionsLoading,
    error
  } = useQuery(GET_ALL_PRICING_PURCHASABLE_PRODUCTS, {
    variables: queryVariables,
    skip: currencyLoading || !displayedCurrencyCode
  });
  const purchaseableProducts = data === null || data === void 0 || (_data$bulkPurchaseOpt = data.bulkPurchaseOptions) === null || _data$bulkPurchaseOpt === void 0 ? void 0 : _data$bulkPurchaseOpt.allPurchaseableProducts;
  const starterProduct = purchaseableProducts === null || purchaseableProducts === void 0 ? void 0 : purchaseableProducts[STARTER_PRODUCT_API_NAME];

  // Find annual and monthly purchase options
  const annualPurchaseOption = starterProduct === null || starterProduct === void 0 || (_starterProduct$purch = starterProduct.purchaseOptions) === null || _starterProduct$purch === void 0 ? void 0 : _starterProduct$purch.find(option => {
    var _option$offerInfo;
    return ((_option$offerInfo = option.offerInfo) === null || _option$offerInfo === void 0 ? void 0 : _option$offerInfo.payment) === 'annual';
  });
  const monthlyPurchaseOption = starterProduct === null || starterProduct === void 0 || (_starterProduct$purch2 = starterProduct.purchaseOptions) === null || _starterProduct$purch2 === void 0 ? void 0 : _starterProduct$purch2.find(option => {
    var _option$offerInfo2;
    return ((_option$offerInfo2 = option.offerInfo) === null || _option$offerInfo2 === void 0 ? void 0 : _option$offerInfo2.payment) === 'monthly';
  });
  const annualPrice = annualPurchaseOption === null || annualPurchaseOption === void 0 || (_annualPurchaseOption = annualPurchaseOption.monthly) === null || _annualPurchaseOption === void 0 ? void 0 : _annualPurchaseOption.calculatedPrice;
  const monthlyPrice = monthlyPurchaseOption === null || monthlyPurchaseOption === void 0 || (_monthlyPurchaseOptio = monthlyPurchaseOption.monthly) === null || _monthlyPurchaseOptio === void 0 ? void 0 : _monthlyPurchaseOptio.calculatedPrice;

  // Check if eligible for promotion
  const eligibleForPromotion = (annualPurchaseOption === null || annualPurchaseOption === void 0 || (_annualPurchaseOption2 = annualPurchaseOption.discounts) === null || _annualPurchaseOption2 === void 0 ? void 0 : _annualPurchaseOption2.some(discount => JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.includes(discount.promotionId))) || (monthlyPurchaseOption === null || monthlyPurchaseOption === void 0 || (_monthlyPurchaseOptio2 = monthlyPurchaseOption.discounts) === null || _monthlyPurchaseOptio2 === void 0 ? void 0 : _monthlyPurchaseOptio2.some(discount => JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.includes(discount.promotionId)));
  const isValidScreenForPromo = INCLUDED_PAGES.includes(screen) && (!tab || tab !== 'ENTERPRISE');
  const loading = currencyLoading || purchaseOptionsLoading;
  const shouldShowBanner = Boolean(!loading && !error && eligibleForPromotion && annualPrice && monthlyPrice && supportedCurrencyCode && isValidScreenForPromo);
  return {
    shouldShowBanner,
    error,
    annualPrice,
    monthlyPrice,
    currencyCode: supportedCurrencyCode,
    loading
  };
};